/**
 * Opens Google Maps driving directions from the user's current location
 * to the supplied destination.
 *
 * @param {{ lat: number, lng: number }} destination
 * @param {string} [fallbackName] – used as destination text when coordinates are unavailable
 * @returns {Promise<void>}
 */
export async function getDirections(destination, fallbackName) {
  const base = 'https://www.google.com/maps/dir/?api=1&travelmode=driving';

  const dest = destination
    ? `${destination.lat},${destination.lng}`
    : encodeURIComponent(fallbackName ?? '');

  if (!dest) {
    alert('No destination coordinates available for this alert.');
    return;
  }

  // Try to get the user's current position for a precise origin.
  // Falls back to Google Maps "from my location" if geolocation is denied/unavailable.
  if (!navigator.geolocation) {
    window.open(`${base}&destination=${dest}`, '_blank');
    return;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const origin = `${coords.latitude},${coords.longitude}`;
        window.open(`${base}&origin=${origin}&destination=${dest}`, '_blank');
        resolve();
      },
      () => {
        // Permission denied or unavailable — let Google Maps choose the origin
        window.open(`${base}&destination=${dest}`, '_blank');
        resolve();
      },
      { timeout: 6000 }
    );
  });
}
